import { Link } from 'react-router-dom'
import { DENTAL_LANDING_PATH, LAW_FIRM_SITE_PATH, LEAD_ENRICHMENT_PATH, TRANSLATION_PLATFORM_PATH } from '@/data/projectDemos'
import { CASABLANCA_CASE_PATH, DARIJA_DEMO_PATH } from '@/data/seoConstants'
import { chromeCopy } from '@/i18n/chrome'
import { href } from '@/i18n/locale'
import { useLocale } from '@/i18n/useLocale'
import { BRAND_NAME } from '@/utils/constants'

export function Footer() {
  const locale = useLocale()
  const copy = chromeCopy[locale]

  const navLinks = [
    { label: copy.services, href: `${href('/', locale)}#services` },
    { label: copy.process, href: `${href('/', locale)}#how-we-work` },
    { label: copy.team, href: `${href('/about', locale)}#team` },
    { label: copy.about, href: `${href('/about', locale)}#about` },
    { label: copy.resources, href: href('/resources', locale) },
    { label: copy.automations, href: href('/automations', locale) },
    { label: copy.morocco, href: href('/ma', locale) },
    // French-only page, so no locale prefix.
    { label: copy.doctorsAgent, href: '/morocco-doctors' },
    { label: copy.caseStudy, href: href(CASABLANCA_CASE_PATH, locale) },
    { label: copy.contact, href: href('/contact', locale) },
  ]

  const workLinks = [
    { label: copy.translationPlatform, href: href(TRANSLATION_PLATFORM_PATH, locale) },
    { label: copy.dentalLanding, href: href(DENTAL_LANDING_PATH, locale) },
    { label: copy.lawFirmSite, href: href(LAW_FIRM_SITE_PATH, locale) },
    { label: copy.leadEnrichment, href: href(LEAD_ENRICHMENT_PATH, locale) },
    { label: copy.darijaDemo, href: href(DARIJA_DEMO_PATH, locale) },
  ]

  return (
    <footer className="fw-editorial w-full bg-fw-white">
      <div className="mx-auto w-full max-w-[1440px] px-6 pb-11 pt-14 md:px-16 md:pt-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 md:gap-12 xl:grid-cols-[1fr_180px_200px_200px] xl:gap-14">
          <div className="flex flex-col gap-3">
            <Link to={href('/', locale)} className="inline-flex items-center gap-2 text-[17px] font-bold tracking-[-0.01em] text-fw-ink">
              Forteuno
              <span className="size-[7px] rounded-full bg-fw-violet" aria-hidden />
            </Link>
            <p className="max-w-xs text-sm text-fw-graphite">{copy.footerBlurb}</p>
          </div>

          <div className="flex flex-col gap-2.5">
            <p className="pb-1 font-fwmono text-[10px] font-medium uppercase tracking-[0.14em] text-fw-muted">
              {copy.navigation}
            </p>
            {navLinks.map((link) => (
              <Link key={link.label} to={link.href} className="text-sm text-fw-graphite hover:text-fw-ink">
                {link.label}
              </Link>
            ))}
          </div>

          <div className="flex flex-col gap-2.5">
            <p className="pb-1 font-fwmono text-[10px] font-medium uppercase tracking-[0.14em] text-fw-muted">
              {copy.selectedWork}
            </p>
            {workLinks.map((link) => (
              <Link key={link.label} to={link.href} className="text-sm text-fw-graphite hover:text-fw-ink">
                {link.label}
              </Link>
            ))}
          </div>

          <div className="flex flex-col gap-2.5">
            <p className="pb-1 font-fwmono text-[10px] font-medium uppercase tracking-[0.14em] text-fw-muted">
              {copy.contact}
            </p>
            <a href="mailto:contact@forteunoweb.com" className="text-sm">
              contact@forteunoweb.com
            </a>
            <a
              href="https://www.linkedin.com/company/forteunoweb-ai/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm"
            >
              LinkedIn
            </a>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-4 border-t border-fw-hairline pt-4 sm:flex-row sm:items-center">
          <p className="text-[13px] text-fw-graphite">
            © {new Date().getFullYear()} {BRAND_NAME}. {copy.reserved}
          </p>
          <div className="flex gap-4 sm:ml-auto">
            <Link to={href('/privacy', locale)} className="text-[13px] text-fw-graphite">{copy.privacy}</Link>
            <Link to={href('/terms', locale)} className="text-[13px] text-fw-graphite">{copy.terms}</Link>
          </div>
        </div>
      </div>
    </footer>
  )
}
